import styled from 'styled-components'
import { breakpoints } from '../../../MediasQueries'

export const BoxDiv = styled.div`
  border-radius: 3px;
  @media (min-width: ${breakpoints.md}) {
    //overflow: auto;
  }
  border-radius: ${(props) => props.radius};
  overflow: ${(props) => props.overflow}!important;
  padding: 1px;
  background: ${({ theme }) => theme.background};
  width: ${(props) => props.width};
  -webkit-box-shadow: 0 0 30px rgb(8 21 66 / 10%);
  box-shadow: 0 0 40px rgb(8 21 66 / 15%);
  padding: ${(props) => props.padding};
  margin: ${(props) => props.margin};
  flex-grow: ${(props) => (props.flex ? '1' : null)};
  min-width: ${(props) => props.minWidth};
`
